export default __webpack_public_path__ + "static/media/Notification.7681271b.svg";